/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllSourceTags200ResponseDataInner } from './FindAllSourceTags200ResponseDataInner';
import {
    FindAllSourceTags200ResponseDataInnerFromJSON,
    FindAllSourceTags200ResponseDataInnerFromJSONTyped,
    FindAllSourceTags200ResponseDataInnerToJSON,
    FindAllSourceTags200ResponseDataInnerToJSONTyped,
} from './FindAllSourceTags200ResponseDataInner';
import type { GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner } from './GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner';
import {
    GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerFromJSON,
    GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerFromJSONTyped,
    GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerToJSON,
    GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerToJSONTyped,
} from './GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner';

/**
 * Source information for the sender of the fax
 * @export
 * @interface FaxDocumentSenderSource
 */
export interface FaxDocumentSenderSource {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    location?: string | null;
    /**
     * 
     */
    contacts?: Array<GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInner>;
    /**
     * 
     */
    phone?: string | null;
    /**
     * 
     */
    email?: string | null;
    /**
     * 
     */
    npi_number?: string | null;
    /**
     * 
     */
    tag_id?: string | null;
    /**
     * 
     */
    type?: string | null;
    /**
     * 
     */
    tag?: FindAllSourceTags200ResponseDataInner;
}

/**
 * Check if a given object implements the FaxDocumentSenderSource interface.
 */
export function instanceOfFaxDocumentSenderSource(value: object): value is FaxDocumentSenderSource {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function FaxDocumentSenderSourceFromJSON(json: any): FaxDocumentSenderSource {
    return FaxDocumentSenderSourceFromJSONTyped(json, false);
}

export function FaxDocumentSenderSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaxDocumentSenderSource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'location': json['location'] === undefined ? undefined : json['location'] === null ? null : json['location'],
        'contacts': json['contacts'] == null ? undefined : ((json['contacts'] as Array<any>).map(GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerFromJSON)),
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'npi_number': json['npi_number'] === undefined ? undefined : json['npi_number'] === null ? null : json['npi_number'],
        'tag_id': json['tag_id'] === undefined ? undefined : json['tag_id'] === null ? null : json['tag_id'],
        'type': json['type'] === undefined ? undefined : json['type'] === null ? null : json['type'],
        'tag': json['tag'] == null ? undefined : FindAllSourceTags200ResponseDataInnerFromJSON(json['tag']),
    };
}

export function FaxDocumentSenderSourceToJSON(json: any): FaxDocumentSenderSource {
    return FaxDocumentSenderSourceToJSONTyped(json, false);
}

export function FaxDocumentSenderSourceToJSONTyped(value?: FaxDocumentSenderSource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'location': value['location'],
        'contacts': value['contacts'] == null ? undefined : ((value['contacts'] as Array<any>).map(GetSourceMergePreview200ResponseDataSourceToMergeSourceContactsInnerToJSON)),
        'phone': value['phone'],
        'email': value['email'],
        'npi_number': value['npi_number'],
        'tag_id': value['tag_id'],
        'type': value['type'],
        'tag': FindAllSourceTags200ResponseDataInnerToJSON(value['tag']),
    };
}

